import { render, staticRenderFns } from "./learningDetails.vue?vue&type=template&id=4532c9ca"
import script from "./learningDetails.vue?vue&type=script&lang=js"
export * from "./learningDetails.vue?vue&type=script&lang=js"
import style0 from "./learningDetails.vue?vue&type=style&index=0&id=4532c9ca&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports